import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Pages/Header";

function Protected(probs) {
  let Cmp = probs.Cmp;
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("user-info")) {
      navigate("/login");
    }
  });
  return (
    <div>
      <Header />
      <div className="pages-container">
        <Cmp />
      </div>
    </div>
  );
}

export default Protected;
